export enum FormSteps {
  CREDIT_PARAMETERS = 1,
  BORROWERS = 2,
  INCOME = 3,
  LIABILITIES = 4
}